import { render, staticRenderFns } from "./BPCreator.vue?vue&type=template&id=dfe8ac12"
import script from "./BPCreator.vue?vue&type=script&lang=js"
export * from "./BPCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports